import React from "react";

export default function LoadingSkeleton({ isDark }) {
  return (
    <div
      className={`w-full overflow-hidden rounded-3xl ${
        isDark
          ? "bg-[#212121] border border-white-alpha-20"
          : "bg-white border border-black-alpha-15"
      }`}
      style={{ boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)" }}
    >
      {/* Header Skeleton */}
      <div className="flex flex-row items-center gap-2 pl-16 pr-8 py-6">
        <div className="flex-1">
          <div
            className={`h-20 w-[140px] rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
        </div>
        <div
          className={`w-20 h-20 rounded-full animate-pulse ${
            isDark ? "bg-grey-600" : "bg-grey-100"
          }`}
        />
      </div>

      {/* Tab Container Skeleton */}
      <div
        className={`flex flex-row items-center border-b animate-pulse ${
          isDark ? "border-white-alpha-05" : "border-black-alpha-05"
        }`}
      >
        <div className="flex items-center justify-center gap-3 py-10 px-16">
          <div
            className={`h-9 w-[120px] rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
        </div>
        <div className="flex items-center justify-center gap-3 py-10 px-16">
          <div
            className={`h-9 w-[85px] rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
        </div>
      </div>

      {/* Score and Description Section Skeleton */}
      <div className="py-12">
        <div className="px-16">
          <div className="flex items-center gap-20">
            {/* Circular Progress Skeleton */}
            <div className="relative h-[73.6px] w-[92px] shrink-0 animate-pulse">
              <div
                className={`h-[73.6px] w-[92px] rounded-lg animate-pulse ${
                  isDark ? "bg-grey-600" : "bg-grey-100"
                }`}
              />
            </div>
            {/* Description Text Skeleton */}
            <div className="flex-1 animate-pulse">
              <div
                className={`h-9 w-full max-w-[328px] rounded-full animate-pulse ${
                  isDark ? "bg-grey-600" : "bg-grey-100"
                }`}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Text Content Area Skeleton */}
      <div className="pt-6 pb-12">
        <div className="px-16 space-y-12 animate-pulse">
          <div
            className={`h-9 w-full rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-full rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-5/6 rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-full rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-4/5 rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-full rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-full rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-full rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
          <div
            className={`h-9 w-1/5 rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
        </div>
      </div>

      {/* Footer Actions Skeleton */}
      <div
        className={`flex flex-row items-center pl-16 pr-8 py-16 gap-8 justify-between border-t ${
          isDark ? "border-white-alpha-05" : "border-black-alpha-05"
        }`}
      >
        <div
          className={`h-40 w-[161px] rounded-full animate-pulse ${
            isDark ? "bg-grey-600" : "bg-grey-100"
          }`}
        />
        <div
          className={`h-20 w-[91px] rounded-full animate-pulse ${
            isDark ? "bg-grey-600" : "bg-grey-100"
          }`}
        />
      </div>
    </div>
  );
}

